import React, { useContext, useEffect } from 'react'
import { useEventHandler, useInstData } from 'tyan/public/hooks'
import { FormDataContext } from 'Tyan/public/components/context'
import Button from './Button'

export default props => {
	const {
		me: { state: { acts = [] } },
		setState
	} = useInstData(props)

	const { config: { _recordflow: flow, disabled, recordFlowForm, icon, onFinish } = {} } = props
	const formData = useContext(FormDataContext) || {}
	const { onClose, onFlowFinished, id: formId = 0 } = { ...(formData.props || {}), ...(formData.state || {}) }
	const id = Object.keys(props.config || {}).includes('id') ? (props.config.id || 0) : formId

	const doShowFlowForm = ({ act, button }) => {
		const { closeDialog } = Tyan.pubForm.showDialog(act.act, recordFlowForm,
			{
				id, flowAct: act,
				onFinish: () => handleFinish({ closeDialog/* : doCloseDialog */, act }),
				onConfirm: ({ values = {}, button, callback }) => doAct({ act, button, values, closeDialog, callback })
			}
		)
	}

	const handleFinish = ({ closeDialog, act }) => {
		closeDialog && closeDialog()
		if (onFinish)
			onFinish(act)
		else {
			Ext.toast('操作成功')
			// Tyan.pubForm.showPrompt('操作成功')
			onClose && onClose()
			onFlowFinished && onFlowFinished(act)
		}
	}

	const doAct = ({ act, button, values = {}, closeDialog, callback }) => {
		const doEvent = () => Tyan.doPostEvent('DoFlowRecordAct', {
			data: { id, operateId: act.operateId, input: values },
			sourceComponent: button,
			onEnd: ({ errorMessage }) => {
				callback && callback()
				// errorMessage && Ext.toast(errorMessage)
				errorMessage && Tyan.pubForm.showError(errorMessage)
				!errorMessage && handleFinish({ closeDialog, act })
			}
		})

		closeDialog ? doEvent() : Tyan.pubForm.showConfirm(`确定要 ${act.act} ?`, doEvent)
	}

	const handleAct = useEventHandler(arg => {
		const { act } = arg
		act.components
			? doShowFlowForm(arg)
			: doAct(arg)
	})


	useEffect(() => {
		Tyan.doPostEvent('GetFlowRecordActs', {
			data: { id },
			onEnd: ({ errorMessage, acts }) => {
				if (errorMessage) {
					// Ext.toast(errorMessage)
					Tyan.pubForm.showError(errorMessage)
					console.error(`取流程信息 ${flow} : ${id} 错误:`, errorMessage)
				} else {
					setState({
						acts: acts.map(act => {
							act.config = { _button: act.act, dest: act.dest, handler: button => handleAct({ act, button }) }
							return act
						})
					})
				}
			}
		})
		setState({ acts: [] })
	}, [flow, id])

	return <>
		{acts.map((act, index) => {
			act.config.disabled = act.config.dest == 'forward' && disabled
			act.config.icon = icon && icon
			return <Button key={`${act.act}_${index}`} config={act.config} />
		})}
	</>
}